import {
  Directive,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  Inject,
  PLATFORM_ID,
  Input,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

// Révélation discrète au scroll : ajoute .mj-reveal (état initial masqué)
// puis .mj-reveal--visible dès l'entrée en viewport, jamais l'inverse — tant
// que le JS n'a pas tourné (SSR, hydratation lente), l'élément n'a aucune de
// ces classes et reste visible par défaut. Les classes elles-mêmes vivent
// dans styles.scss (transition + prefers-reduced-motion) pour être
// partagées par toutes les sections plutôt que dupliquées par composant.
@Directive({
  selector: '[appScrollReveal]',
})
export class ScrollRevealDirective implements AfterViewInit, OnDestroy {
  // Délai de la cascade (ms), utilisé pour l'effet stagger sur les listes *ngFor.
  @Input() revealDelay = 0;

  private observer: IntersectionObserver | null = null;

  constructor(
    private el: ElementRef<HTMLElement>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const host = this.el.nativeElement;
    host.classList.add('mj-reveal');
    if (this.revealDelay) {
      host.style.transitionDelay = `${this.revealDelay}ms`;
    }

    // rootMargin négatif en bas : révèle un peu avant que l'élément n'ait
    // fini d'entrer par le bas du viewport, dans le même esprit que le
    // rootMargin de initSectionObserver (home.component.ts) mais adapté à
    // un déclenchement à l'entrée plutôt qu'au passage au centre du viewport.
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            host.classList.add('mj-reveal--visible');
            this.observer?.unobserve(host);
          }
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    this.observer.observe(host);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
